import { render, staticRenderFns } from "./evalStandard.vue?vue&type=template&id=1b61fb0c&scoped=true"
import script from "./evalStandard.vue?vue&type=script&lang=js"
export * from "./evalStandard.vue?vue&type=script&lang=js"
import style0 from "./evalStandard.vue?vue&type=style&index=0&id=1b61fb0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b61fb0c",
  null
  
)

export default component.exports